import { render } from "./AccountItem.vue?vue&type=template&id=b80d2ef0&scoped=true"
import script from "./AccountItem.vue?vue&type=script&lang=js"
export * from "./AccountItem.vue?vue&type=script&lang=js"

import "./AccountItem.vue?vue&type=style&index=0&id=b80d2ef0&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b80d2ef0"]])

export default __exports__